import "./CallOutTextColumnBlock.scss";
import {
  BulletListCallOut,
  Label,
  Link,
  OptimizelyEditProperty,
} from "/App.Components";
import { CallOutTextColumnBlockProps } from "/Models/Generated/CallOutTextColumnBlockProps";

const CallOutTextColumnBlock = ({
  heading,
  headingPropertyName,
  label,
  labelPropertyName,
  leadText,
  leadTextPropertyName,
  listItems,
  listItemsPropertyName,
  readMoreLink,
  readMoreLinkPropertyName,
}: CallOutTextColumnBlockProps) => {
  return (
    <div className="call-out-text-column-block-norad">
      {(label || labelPropertyName) && (
        <div className="call-out-text-column-block-norad__label-container">
          <OptimizelyEditProperty propertyName={labelPropertyName}>
            {label && <Label text={label} isExternal={false} outlined />}
          </OptimizelyEditProperty>
        </div>
      )}
      <OptimizelyEditProperty propertyName={headingPropertyName}>
        <h2 className="call-out-text-column-block-norad__heading">{heading}</h2>
      </OptimizelyEditProperty>
      <OptimizelyEditProperty propertyName={leadTextPropertyName}>
        <p className="call-out-text-column-block-norad__text">{leadText}</p>
      </OptimizelyEditProperty>
      <OptimizelyEditProperty propertyName={listItemsPropertyName}>
        <div className="call-out-text-column-block-norad__list">
          {listItems && (
            <BulletListCallOut>
              {listItems.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </BulletListCallOut>
          )}
        </div>
      </OptimizelyEditProperty>
      <OptimizelyEditProperty propertyName={readMoreLinkPropertyName}>
        <div className="call-out-text-column-block-norad__link">
          <Link
            {...readMoreLink}
            isExternal={readMoreLink?.isExternal ?? false}
            hasUnderline
            size="x-small"
          />
        </div>
      </OptimizelyEditProperty>
    </div>
  );
};

export default CallOutTextColumnBlock;
